import Swiper, {A11y, Autoplay, EffectFade, Navigation, Pagination, Parallax} from 'swiper'

const body = document.querySelector('body');
const home = body.classList.contains('home');

if (home) {

    // Slider home
    const homeSlideshow = document.querySelector('.slideshow .swiper-container') !== null;

    if (homeSlideshow) {
        let nbSlides = document.querySelectorAll('.slideshow .swiper-container .swiper-slide').length;
        let dataSlideAuto = document.querySelector('.slideshow .swiper-container').getAttribute('data-slide_auto');
        let dataSlideSpeed = document.querySelector('.slideshow .swiper-container').getAttribute('data-slide_speed');
        dataSlideSpeed = dataSlideSpeed + '000';

        Swiper.use([A11y, Autoplay, EffectFade, Navigation, Pagination, Parallax]);

        let config = {
            centeredSlides: true,
            speed: 1000,
            // parallax: true,


            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },

            // Pagination (bullet)
            pagination: {
                el: '.c-pagination__bullets',
                type: 'bullets', // default
                clickable: true,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                paginationBulletMessage: 'Aller à la diapositive {{index}}',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },
        }

        if (dataSlideAuto === '1') {
            config.autoplay = {
                delay: dataSlideSpeed,
                disableOnInteraction: false,
            }
        }

        if (nbSlides > 1) {
            let swiperHome = new Swiper(".slideshow .swiper-container", config);
 
            if (dataSlideAuto === "1") {
                let boutonPlayPause = document.getElementById("js-boutonAutoplay");
                let iconPause = boutonPlayPause.querySelector(".nav-swiper-autoplay__icon--pause");
                let iconPlay = boutonPlayPause.querySelector(".nav-swiper-autoplay__icon--play");
 
              // Initial state adjustment
                if (swiperHome.autoplay.running) {
                    iconPause.classList.remove("hidden");
                    iconPlay.classList.add("hidden");
                } else {
                    iconPause.classList.add("hidden");
                    iconPlay.classList.remove("hidden");
                }
 
              boutonPlayPause.addEventListener("click", function () {
                if (swiperHome.autoplay.running) {
                  swiperHome.autoplay.stop();
 
                  boutonPlayPause.classList.remove("nav-swiper-autoplay--play");
                  boutonPlayPause.classList.add("nav-swiper-autoplay--pause");
                  iconPause.classList.add("hidden");
                  iconPlay.classList.remove("hidden");
                } else {
                  swiperHome.autoplay.start();
 
                  boutonPlayPause.classList.remove("nav-swiper-autoplay--pause");
                  boutonPlayPause.classList.add("nav-swiper-autoplay--play");
                  iconPause.classList.remove("hidden");
                  iconPlay.classList.add("hidden");
                }
              });
            }
          }
    }

    // slider Actualités
    const newsSlideshow = document.querySelector('.news .swiper-container') !== null;

    if (newsSlideshow) {
      let newsSlides = document.querySelectorAll('.news .swiper-container .swiper-slide').length;

      Swiper.use([ A11y, Navigation ]);

      let newsConfig = {
        effect : 'slide',
        grabCursor : 'true',
        speed: 700,
        loop: true,
        slidesPerView: 'auto',

        breakpoints: {
          1201: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          961: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          801: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          0: {
            slidesPerView: 1,
            spaceBetween: 20,
          }
        },
        
        keyboard: {
          enabled: true,
        },

        mousewheel: {
          forceToAxis: true,
          releaseOnEdges : true,
        },

        navigation: {
          nextEl: `.news .news__navigation-button--next`,
          prevEl: `.news .news__navigation-button--prev`,
        },

        a11y: {
          enabled: true,
          prevSlideMessage: 'Diapositive précédente',
          nextSlideMessage: 'Diapositive suivante',
          slideLabelMessage: '{{index}} / {{slidesLength}}', // default
        }
      }

      if(newsSlides >= 1) {
        let swiperNews = new Swiper('.news .swiper-container', newsConfig);
      }
    }

    // Slider Kiosque
    const kiosqueSlideshow = document.querySelector('.kiosque .swiper-container') !== null;

    if (kiosqueSlideshow) {
      let kiosqueSlides = document.querySelectorAll('.kiosque .swiper-container .swiper-slide').length;

      Swiper.use([A11y, EffectFade, Navigation]);

      let kiosqueConfig = {
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        grabCursor: true,
        speed: 700,
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,

        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
        },

        navigation: {
          nextEl: '.kiosque .kiosque__navigation-button--next',
          prevEl: '.kiosque .kiosque__navigation-button--prev',
        },

        a11y: {
          enabled: true,
          prevSlideMessage: 'Publication précédente',
          nextSlideMessage: 'Publication suivante',
          slideLabelMessage: '{{index}} / {{slidesLength}}',
        },
      };

      if (kiosqueSlides > 1) {
        new Swiper('.kiosque .swiper-container', kiosqueConfig);
      }
    }

}
